export default {
  state: {
    scheduling: {
      date: null,
      time: null,
      form: {},
      indefinida: false,
      walinglist: false,
    },
    stopList: false,
  },
  getters: {
    getScheduling: (state) => {
      return state.scheduling;
    },
    getStopList: (state) => {
      return state.stopList;
    },
  },
  mutations: {
    setScheduling: (state, playload) => {
      state.scheduling = Object.assign(state.scheduling, playload);
    },
    setForm: (state, playload) => {
      state.scheduling.form = { ...state.scheduling.form, ...playload };
    },
    setStopList: (state, playload) => {
      state.stopList = playload;
    },
  },
};
